import { forwardRef, KeyboardEvent, ReactNode } from 'react';

import { Typography } from '@mui/material';
import TextField, { TextFieldProps } from '@mui/material/TextField';

import theme from 'src/theme';

type BaseTextFieldProps = TextFieldProps & {
  onEnter?: Function;
  'data-testid'?: string;
};

type TextFieldWithLabel = TextFieldProps & {
  label: ReactNode;
};

const BaseTextField = (props: BaseTextFieldProps, ref: any) => {
  const { onEnter, inputProps, 'data-testid': dataTestId, ...filteredProps } = props;

  const onKeyDown = (event: KeyboardEvent<HTMLImageElement>) => {
    if (event.key === 'Enter') {
      if (onEnter) onEnter(event);
    }
  };
  return (
    <TextField
      ref={ref}
      inputProps={{ 'data-testid': dataTestId, ...inputProps }}
      {...filteredProps}
      onKeyDown={onKeyDown}
    />
  );
};

export const TextFieldWithLabel = (props: TextFieldProps & { errorMessage?: string }) => {
  const { label, required, error: isError, errorMessage, ...filteredProps } = props;
  return (
    <>
      <Typography variant="h7">
        {required && (
          <Typography variant="h7" component="span" color="errorDark.main" sx={{ mr: 0.2 }}>
            *
          </Typography>
        )}
        {label}
        <TextField
          error={isError}
          {...filteredProps}
          size="small"
          fullWidth
          sx={{
            '& .MuiFormHelperText-root': {
              marginTop: '-4px',
            },
            '& .MuiInputBase-root': {
              height: '40px',
            },
          }}
        />
      </Typography>
      {!!isError && errorMessage ? (
        <Typography sx={{ fontWeight: 400, fontSize: '18px', color: theme.palette.error.main }}>
          {errorMessage}
        </Typography>
      ) : null}
    </>
  );
};

export default forwardRef(BaseTextField);
